import React, { useState, useEffect } from "react";
import './CalendarCard.css';
import moment from 'moment-timezone';
import { format, parse } from 'date-fns';
// import
// console.log("process.env.SERVERURL", process.env.REACT_APP_SERVERURL);

const CalendarCard = () => {
    const [dayDetails, setDayDetails] = useState(null);
    const [timeDetails, setTimeDetails] = useState(null);
    const [virathaDetails, setVirathaDetails] = useState([]);
    const [rasiDetails, setRasiDetails] = useState(null);
    const [raguKuligaiEmakandam, setRaguKuligaiEmakandam] = useState(null);
    const [raguKuligaiEmakandamAdditional, setRaguKuligaiEmakandamAdditional] = useState(null);
    const [selectedNewDate, setSelectedNewDate] = useState(moment().tz("Asia/Kolkata"));
    const [starDetails, setStarDetails] = useState(null);
    const [rasiBoxDetails, setRasiBoxDetails] = useState(null);
    const dateInputRef = React.useRef(null);
    const [minDate, setMinDate] = useState(null);
    const [maxDate, setMaxDate] = useState(null);
    const [loading, setLoading] = useState(true);
    const [selectedText, setSelectedText] = useState(null);
    const [selectedPirai, setSelectedPirai] = useState(null)

    const [popup, setPopup] = useState({ show: false, text: '', index: null });

    const showPopup = (text, index) => {
        setPopup({ show: true, text, index });

        // Hide after 1 second
        setTimeout(() => {
            setPopup({ show: false, text: '', index: null });
        }, 1000);
    };

    const clearAllDetails = () => {
        setLoading(true);
        setDayDetails(null);
        setTimeDetails(null);
        setVirathaDetails([]);
        setRasiDetails(null);
        setRaguKuligaiEmakandam(null);
        setRaguKuligaiEmakandamAdditional(null);
        setStarDetails(null);
        setRasiBoxDetails(null);
        setSelectedText(null);
        setSelectedPirai(null);
    };
    const raasiNames = {
        1: "மேஷம்",
        2: "ரிஷபம்",
        3: "மிதுனம்",
        4: "கடகம்",
        5: "சிம்மம்",
        6: "கன்னி",
        7: "துலாம்",
        8: "விருச்சிகம்",
        9: "தனுசு",
        10: "மகரம்",
        11: "கும்பம்",
        12: "மீனம்",
    };

    const dayTypeValues = {
        1: "மேல் நோக்கு நாள்",
        2: "கீழ் நோக்கு நாள்",
        3: "சம நோக்கு நாள்"
    };

    const dayTypeValuesImage = {
        1: "/melnokku.png",
        2: "/keelnokku.png",
        3: "/samanokku.png"
    }
    const dayTypeValuesText = {
        "/melnokku.png": "மேல் நோக்கு நாள்",
        "/keelnokku.png": "கீழ் நோக்கு நாள்",
        "/samanokku.png": "சம நோக்கு நாள்"
    }
    const piraiValues = {
        1: "1",
        2: "2"
    };
    const piraiValuesImage = {
        1: "/theypirai.png",
        2: "/valar_pirai.png"
    }

    const piraiValuesText = {
        "/theypirai.png": "தேய்பிறை",
        "/valar_pirai.png": "வளர்பிறை"
    }

    function getVirathamImage(str) {
        // console.log("viratham day in adapter", str);

        if (str.includes("கிருத்திகை") || str.includes("கார்த்திகை")) {
            return "/karthigai.png";
        }
        if (str.includes("பௌர்ணமி")) {
            return "/fullmoon.png";
        }
        if (str.includes("அமாவாசை")) {
            return "/blackmoon.png";
        }
        if (str.includes("ஏகாதசி")) {
            return "/ekadasi.png";
        }

        if (str.includes("சஷ்டி")) {
            return "/shasti.png";
        }

        if (str.includes("சங்கடஹர சதுர்த்தி")) {
            return "/sankataharachaturti.png";
        }

        if (str.includes("சிவராத்திரி")) {
            return "/shivaratri.png";
        }

        if (str.includes("பிரதோஷம்")) {
            return "/pirathoosam.png";
        }

        if (str === "சதுர்த்தி") {
            return "/chaturthi.png";
        }

        if (str.includes("திருவோணம்")) {
            return "/thiruvona.png";
        }
        return "";
    }

    function dateCange(inputDate) {
        var parsed = parse(inputDate, "d/m/yyyy", new Date());

        // Format to yyyy-MM-dd
        return format(parsed, "yyyy-mm-dd");

    }


    useEffect(() => {
        getDetails();

    }, []);

    const getImageByDayType = (inputText) => {
        const dayTypeKeys = Object.fromEntries(
            Object.entries(dayTypeValues).map(([k, v]) => [v, k])
        );
        return dayTypeValuesImage[dayTypeKeys[inputText]] || "";


    };

    const getImageByPirai = (inputText) => {
        const piraiKeys = Object.fromEntries(
            Object.entries(piraiValues).map(([k, v]) => [v, k])
        );
        return piraiValuesImage[piraiKeys[inputText]] || "";


    };

    const handleIconClick = () => {
        dateInputRef.current.showPicker?.();
        dateInputRef.current.click();
    };

    const handleDateChange = (e) => {
        const selectedDate = e.target.value;

        if (selectedDate) {
            const momentDate = moment(selectedDate).tz("Asia/Kolkata");
            setSelectedNewDate(momentDate)
            getNewDetails(selectedDate);
        }
    };
    const refreshDate = () => {
        const momentDate = moment().tz("Asia/Kolkata");
        setSelectedNewDate(momentDate)
        getDetails();

    }
    const handlePrevious = () => {
        const newDate = selectedNewDate.clone().subtract(1, "day");
        setSelectedNewDate(newDate);
        getNewDetails(newDate.format("YYYY-MM-DD"));
    };

    const handleNext = () => {
        const newDate = selectedNewDate.clone().add(1, "day");
        setSelectedNewDate(newDate);
        getNewDetails(newDate.format("YYYY-MM-DD"));
    };
    const getNewDetails = async (selectedDate) => {
        clearAllDetails();
        const [year, month, day] = selectedDate.split("-");
        const dayOfWeek = moment(selectedDate).tz("Asia/Kolkata").day();
        // console.log("sel year...", year);
        // console.log("day...", day);
        fetchBirthDeath(day, month);
        fetchGoodTime(selectedDate);
        fetchVirathaDay(selectedDate);
        fetchRasiDetails(selectedDate);
        fetchRaguKuligaiEmakandam(year, dayOfWeek);
        fetchRaguKuligaiEmakandamAdditional(selectedDate);
        const formattedDate = `${day}-${month}-${year}`;
        fetchStarDetails(formattedDate);
        fetchRasiBoxDetails(formattedDate);
        // setLoading(false);
    };
    const getDetails = async () => {
        const today = moment().tz('Asia/Kolkata');
        const today_formattedDate = today.format('YYYY-MM-DD');
        const todayDate = today.date();
        const currentMonth = today.month() + 1;
        fetchDateLimt();
        fetchBirthDeath(todayDate, currentMonth);
        fetchGoodTime(today_formattedDate);
        fetchVirathaDay(today_formattedDate);
        fetchRasiDetails(today_formattedDate);
        fetchRaguKuligaiEmakandam(today.year(), today.day());
        fetchRaguKuligaiEmakandamAdditional(today_formattedDate);
        fetchStarDetails(today.format('DD-MM-YYYY'));
        fetchRasiBoxDetails(today.format('DD-MM-YYYY'));
        // setLoading(false);
    };
    const fetchDateLimt = async () => {
        // Gets the month (0-11), so add 1
        const url = `${process.env.REACT_APP_SERVERURL}/get_date_limit`;
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {
                // console.log("day... startdate enddate", data);
                if (data && data.length > 0) { // store the first record
                    setMaxDate(dateCange(data[0].endDate));
                    setMinDate(dateCange(data[0].startDate));// store the first record
                    // console.log("minDate", dateCange(data[0].startDate));
                    // console.log("maxDate", dateCange(data[0].endDate));
                } else {
                    setMinDate(null);
                    setMaxDate(null);  // no record found
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setMinDate(null);
                setMaxDate(null); // fallback in case of error
            });
    };

    const fetchBirthDeath = async (todayDate, currentMonth) => {
        // Gets the month (0-11), so add 1
        const url = `${process.env.REACT_APP_SERVERURL}/get_day_details?date=${todayDate}&month=${currentMonth}`;
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {
                // console.log("day... details", data);
                if (data && data.length > 0) {
                    setDayDetails(data[0]); // store the first record
                } else {
                    setDayDetails(null); // no record found
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setDayDetails(null); // fallback in case of error
            });
    };
    const fetchGoodTime = async (todayDate) => {
        // Gets the month (0-11), so add 1
        // console.log("tttttt", todayDate);
        const url = `${process.env.REACT_APP_SERVERURL}/get_time_details?date=${todayDate}`;
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {

                //console.log("time... details", data);
                if (data && data.length > 0) {
                    setTimeDetails(data[0]);

                } else {
                    setTimeDetails(null); // no record found
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setTimeDetails(null); // fallback in case of error
            });
    };
    const fetchVirathaDay = async (todayDate) => {
        // Gets the month (0-11), so add 1
        // console.log("tttttt", todayDate);
        const url = `${process.env.REACT_APP_SERVERURL}/get_viratha_details?date=${todayDate}`;
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {

                //console.log("time... details", data);
                if (data && data.length > 0) {
                    setVirathaDetails(data);
                    // console.log("subaMugurtham", data[0].viratham);
                    // console.log("vvvvvv", data);// store the first record
                } else {
                    setVirathaDetails([]);  // no record found
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setVirathaDetails([]);  // fallback in case of error
            });
    };
    const fetchRasiDetails = async (todayDate) => {
        // Gets the month (0-11), so add 1
        // console.log("tttttt", todayDate);
        const url = `${process.env.REACT_APP_SERVERURL}/get_rasi_details?date=${todayDate}`;
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {

                //console.log("time... details", data);
                if (data && data.length > 0) {
                    setRasiDetails(data[0]); // store the first record
                } else {
                    setRasiDetails(null); // no record found
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setRasiDetails(null); // fallback in case of error
            });
    };
    const fetchRaguKuligaiEmakandam = async (year, dayOfWeekIndex) => {
        const tamilWeekDays = [
            "ஞாயிறு", // Sunday
            "திங்கள்", // Monday
            "செவ்வாய்", // Tuesday
            "புதன்", // Wednesday
            "வியாழன்", // Thursday
            "வெள்ளி", // Friday
            "சனி"    // Saturday
        ];
        const tamilWeekDay = tamilWeekDays[dayOfWeekIndex];
        const url = `${process.env.REACT_APP_SERVERURL}/get_ragu_kuligai_details?year=${year}&weekday=${tamilWeekDay}`;
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {

                //console.log("time... details", data);
                if (data && data.length > 0) {
                    setRaguKuligaiEmakandam(data[0]); // store the first record
                } else {
                    setRaguKuligaiEmakandam(null); // no record found
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setRaguKuligaiEmakandam(null); // fallback in case of error
            });
    };

    const fetchRaguKuligaiEmakandamAdditional = async (todayDate) => {
        // Gets the month (0-11), so add 1
        // console.log("tttttt", todayDate);
        const url = `${process.env.REACT_APP_SERVERURL}/get_ragu_kuligai_additional_details?date=${todayDate}`;
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {

                //console.log("time... details", data);
                if (data && data.length > 0) {
                    setRaguKuligaiEmakandamAdditional(data[0]); // store the first record
                    // console.log("raguKuligaiEmakandamAdditional", data[0].day_type);
                    setSelectedText(getImageByDayType(data[0].day_type ? data[0].day_type : null));
                    setSelectedPirai(getImageByPirai(data[0].pirai ? data[0].pirai : null));
                } else {
                    setRaguKuligaiEmakandamAdditional(null); // no record found
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setRaguKuligaiEmakandamAdditional(null); // fallback in case of error
            });
    };
    const fetchStarDetails = async (todayDate) => {
        const url = `${process.env.REACT_APP_SERVERURL}/get_star_details?date=${todayDate}`;
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {

                // console.log("star... details", data);
                if (data && data.length > 0) {
                    setStarDetails(data[0]); // store the first record
                } else {
                    setStarDetails(null); // no record found
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setStarDetails(null); // fallback in case of error
            });
    };

    const fetchRasiBoxDetails = async (todayDate) => {
        const url = `${process.env.REACT_APP_SERVERURL}/get_rasi_box_details?date=${todayDate}`;
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {
                setLoading(false);
                // console.log("box... details", data);
                if (data && data.length > 0) {
                    setRasiBoxDetails(data[0]); // store the first record
                } else {
                    setRasiBoxDetails(null); // no record found
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setRasiBoxDetails(null); // fallback in case of error
            });
    };

    function poluthuGet(strDate, strr1) {
        // Remove AM/PM and split time
        const strr = strr1.replace(/:/g, ".");
        const timee = strr.replace(/\s?(AM|PM)/g, "");
        const output = timee.split(".");

        let hourOfDay;
        if (strr1.includes("PM")) {
            hourOfDay = parseInt(output[0]) !== 12 ? parseInt(output[0]) + 12 : 12;
        } else {
            hourOfDay = parseInt(output[0]) === 12 ? 0 : parseInt(output[0]);
        }

        // Log for debugging
        // console.log(`hourOfDay == : ${hourOfDay} - ${strDate}`);

        if (hourOfDay >= 0 && hourOfDay <= 5) {
            return "அதிகாலை";
        } else if (hourOfDay >= 6 && hourOfDay <= 11) {
            return "காலை";
        } else if (hourOfDay >= 12 && hourOfDay <= 14) {
            return "பிற்பகல்";
        } else if (hourOfDay >= 15 && hourOfDay <= 18) {
            return "மாலை";
        } else if (hourOfDay >= 19 && hourOfDay <= 24) {
            return "இரவு";
        } else {
            return ""; // Fallback case
        }
    }

    // function starGet(timeDetails) {
    //     if (!timeDetails) return ""; // No data
    //     const { Time1, Time2, Nat1, Nat2, Nat3 } = timeDetails;

    //     const time1Str = Time1.replace(/:/g, ".");
    //     const time2Str = Time2.replace(/:/g, ".");
    //     const str = timeDetails.date;
    //     if (Time1 === "-") {
    //         return Nat1 === "-" ? "-" : `இன்று முழுவதும் ${Nat1}`;
    //     } else {
    //         if (Time2 !== "-") {
    //             return (
    //                 `இன்று ${poluthuGet(str, Time1)} ${time1Str.replace(/ AM| PM/g, "")} வரை ${Nat1}` +
    //                 ` பின்பு ${poluthuGet(str, Time2)} ${time2Str.replace(/ AM| PM/g, "")} வரை ${Nat2} பின்பு ${Nat3}`
    //             );
    //         } else {
    //             return (
    //                 `இன்று ${poluthuGet(str, Time1)} ${time1Str.replace(/ AM| PM/g, "")} வரை ${Nat1}` +
    //                 ` பின்பு ${Nat2}`
    //             );
    //         }
    //     }
    // }
    function starGet(starDetails) {
        if (!starDetails) return ""; // No data

        const { Time1, Time2, Nat1, Nat2, Nat3, date } = starDetails;

        // Ensure Time1 and Time2 are valid strings
        const time1Str = typeof Time1 === "string" ? Time1.replace(/:/g, ".") : "";
        const time2Str = typeof Time2 === "string" ? Time2.replace(/:/g, ".") : "";
        const str = date || ""; // Fallback if date is undefined

        // console.log("time1Str:", Time1);
        // console.log("time2Str:", Time2);
        // console.log("str:", str);

        if (Time1 === "-" || !Time1) {
            return Nat1 === "-" || !Nat1 ? "-" : `இன்று முழுவதும் ${Nat1}`;
        } else {
            if (Time2 && Time2 !== "-") {
                return (
                    `இன்று ${poluthuGet(str, Time1)} ${time1Str.replace(/ AM| PM/g, "")} வரை ${Nat1}` +
                    ` பின்பு ${poluthuGet(str, Time2)} ${time2Str.replace(/ AM| PM/g, "")} வரை ${Nat2} பின்பு ${Nat3}`
                );
            } else {
                return (
                    `இன்று ${poluthuGet(str, Time1)} ${time1Str.replace(/ AM| PM/g, "")} வரை ${Nat1}` +
                    ` பின்பு ${Nat2}`
                );
            }
        }
    }

    const specialValues = [
        dayDetails?.imp_day,
        raguKuligaiEmakandamAdditional?.importantday,
        raguKuligaiEmakandamAdditional?.hindu_fes,
        raguKuligaiEmakandamAdditional?.muslim_fes,
        raguKuligaiEmakandamAdditional?.chirs_fes,
        raguKuligaiEmakandamAdditional?.gov_holiday,
    ].filter(value => value && value.trim() !== '-');

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <div className="container my-3 calendar-wrapper" >
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center header-bar shadow-sm rounded" style={{ padding: '10px 10px' }}>
                <div className="header-title" style={{ color: "#e53935" }}>தினசரி காலண்டர்</div>

                <div className="d-flex gap-2 header-icons">
                    <i
                        className="bi bi-arrow-clockwise"
                        style={{ cursor: "pointer" }}
                        onClick={refreshDate}
                    />
                    <div>

                    </div>
                    <i
                        className="bi bi-calendar"
                        style={{ cursor: "pointer" }}
                        onClick={handleIconClick}
                    />
                    <input
                        ref={dateInputRef}
                        type="date"
                        min={minDate}
                        max={maxDate}
                        value={selectedNewDate.format("YYYY-MM-DD")}
                        style={{ display: "none" }}
                        onChange={handleDateChange}
                    />
                </div>
            </div>

            {/* Date Card */}

            <div className="date-card my-2 text-center rounded shadow-sm p-3 d-flex justify-content-between align-items-center">
                {selectedNewDate.format("YYYY-MM-DD") !== minDate ?
                    <i
                        className="bi bi-chevron-left fs-4 text-white"
                        style={{ cursor: "pointer" }}
                        onClick={handlePrevious}
                    />
                    : <i className="bi bi-chevron-left fs-4" style={{ cursor: "not-allowed", color: "#e53935" }} />
                }
                {timeDetails && (
                    <div>
                        <div className="month-day fw-bold">{timeDetails.month} - {timeDetails.weekday}</div>
                        <h2 className="date-text m-0">{timeDetails.date.replace(/\//g, '-')}</h2>
                        <div className="date-details">{timeDetails.tam_year} - {timeDetails.tam_month} - {timeDetails.tam_day}</div>
                        {/* <div className="date-details">உத்திராயணம் - {timeDetails.tam_year} - {timeDetails.tam_month} - {timeDetails.tam_day}</div> */}
                    </div>
                )}
                {selectedNewDate.format("YYYY-MM-DD") !== maxDate ?
                    <i
                        className="bi bi-chevron-right fs-4 text-white"
                        style={{ cursor: "pointer" }}
                        onClick={handleNext}
                    />
                    : <i className="bi bi-chevron-right fs-4" style={{ cursor: "not-allowed", color: "#e53935" }} />
                }

            </div>


            {/* Special Note */}
            <div
                style={{
                    backgroundColor: '#f5f5f5',
                    padding: '8px',
                    textAlign: 'center',
                    borderRadius: '4px',
                }}>
                {raguKuligaiEmakandamAdditional?.leave_flag === 1 && (
                    <div className="special-text text-center py-1" style={{ color: 'red', fontSize: '18px' }}>
                        அரசு விடுமுறை
                    </div>
                )}

                <div className="timing-card my-3 border rounded shadow-sm overflow-hidden ">
                    {/* Create finalVirathamString */}
                    {virathaDetails && virathaDetails.length > 0 && (
                        <div className="row text-center text-white header-row py-1">
                            <div
                                className="card-header red-header"
                                style={{
                                    paddingLeft: '1rem',
                                    paddingRight: '1rem',
                                    fontSize: '16px',
                                }}
                            >
                                {virathaDetails
                                    .map(item =>
                                        item.time && item.time.trim() !== '-'
                                            ? `${item.viratham} (${item.time})`
                                            : item.viratham
                                    )
                                    .join(', ')
                                }
                            </div>
                        </div>
                    )}




                    <div className="moon-icon text-center">

                        {virathaDetails && virathaDetails.length > 0 && (
                            virathaDetails
                                .map((item, index) =>
                                    item.viratham && item.viratham.trim() !== 'சுபமுகூர்த்தம்' &&
                                    getVirathamImage(item.viratham) && item.viratham.trim() !== '' && (
                                        <div key={item.viratham + index} style={{ position: 'relative', display: 'inline-block' }}>
                                            {popup.show && popup.index === index && (
                                                <div style={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '-80%', // Push it to the right of the image
                                                    transform: 'translateY(-50%)', // Vertically center it
                                                    backgroundColor: '#333',
                                                    color: '#fff',
                                                    padding: '5px 10px',
                                                    borderRadius: '4px',
                                                    fontSize: '12px',
                                                    whiteSpace: 'nowrap',
                                                    zIndex: 1000,
                                                    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
                                                }}>
                                                    {popup.text}
                                                </div>
                                            )}
                                            <img src={getVirathamImage(item.viratham)} alt={index} height={40} key={index}
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => showPopup(item.viratham, index)}
                                                onMouseOver={() => showPopup(item.viratham, index)}></img>
                                        </div>

                                    )

                                )

                        )}

                        {virathaDetails && virathaDetails.length > 0 && (
                            virathaDetails
                                .map((item, index) =>
                                    item.viratham && item.viratham.trim() === 'சுபமுகூர்த்தம்' && (
                                        <div key={item.viratham + index} style={{ position: 'relative', display: 'inline-block' }}>
                                            {popup.show && popup.index === index && (
                                                <div style={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '-80%', // Push it to the right of the image
                                                    transform: 'translateY(-50%)', // Vertically center it
                                                    backgroundColor: '#333',
                                                    color: '#fff',
                                                    padding: '5px 10px',
                                                    borderRadius: '4px',
                                                    fontSize: '12px',
                                                    whiteSpace: 'nowrap',
                                                    zIndex: 1000,
                                                    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
                                                }}>
                                                    {popup.text}
                                                </div>
                                            )}
                                            <img src={"/subamuhurtham.png"} alt="" height={40} key={index}
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => showPopup(item.viratham, index)}
                                                onMouseOver={() => showPopup(item.viratham, index)}></img>
                                        </div>
                                    )

                                )

                        )}
                        {selectedPirai && (
                            <div style={{ position: 'relative', display: 'inline-block' }}>
                                {popup.show && popup.index === 101 && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '-80%', // Push it to the right of the image
                                        transform: 'translateY(-50%)', // Vertically center it
                                        backgroundColor: '#333',
                                        color: '#fff',
                                        padding: '5px 10px',
                                        borderRadius: '4px',
                                        fontSize: '12px',
                                        whiteSpace: 'nowrap',
                                        zIndex: 1000,
                                        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
                                    }}>
                                        {popup.text}
                                    </div>
                                )}
                                <img src={selectedPirai} alt="" height={40}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => showPopup(piraiValuesText[selectedPirai], 101)}
                                    onMouseOver={() => showPopup(piraiValuesText[selectedPirai], 101)} />
                            </div>
                        )}
                        {selectedText && (
                            <div style={{ position: 'relative', display: 'inline-block' }}>
                                {popup.show && popup.index === 102 && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '-80%', // Push it to the right of the image
                                        transform: 'translateY(-50%)', // Vertically center it
                                        backgroundColor: '#333',
                                        color: '#fff',
                                        padding: '5px 10px',
                                        borderRadius: '4px',
                                        fontSize: '12px',
                                        whiteSpace: 'nowrap',
                                        zIndex: 1000,
                                        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
                                    }}>
                                        {popup.text}
                                    </div>
                                )}
                                <img src={selectedText} alt="" height={40}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => showPopup(dayTypeValuesText[selectedText], 102)}
                                    onMouseOver={() => showPopup(dayTypeValuesText[selectedText], 102)}></img>
                            </div>
                        )}
                        {/* <img src={selectedText} alt="" height={40} /> */}
                    </div>


                    {specialValues.length > 0 && (
                        <>
                            <div className="special-text text-center py-1"></div>
                            <div className="dotted-line"></div>
                            <div className="special-text text-center py-2">
                                {specialValues.join(', ')}
                            </div>
                        </>
                    )}



                </div>
                {/* Timings */}

                {timeDetails && (

                    <div>
                        <div className="timing-card my-3 border rounded shadow-sm overflow-hidden ">

                            <div className="row text-center text-white header-row py-1">
                                <div className="card-header red-header">நல்ல நேரம்</div> </div>
                            <div className="row text-center body-row py-2">
                                <div className="col ">காலை</div>
                                <div className="col">{timeDetails.nallanerem_m}</div>
                            </div>
                            <div className="dotted-line"></div>
                            <div className="row text-center body-row  py-2">
                                <div className="col ">மாலை</div>
                                <div className="col">{timeDetails.nallanerem_e}</div>
                            </div>
                        </div>

                        <div className="timing-card my-3 border rounded shadow-sm overflow-hidden ">
                            <div className="row text-center text-white header-row py-1">
                                <div className="card-header red-header">கெளரி நல்ல நேரம்</div>
                            </div>
                            <div className="row text-center body-row  py-2">
                                <div className="col ">காலை</div>
                                <div className="col">{timeDetails.gowrineram_m ?? "-"}</div>
                            </div>
                            <div className="dotted-line"></div>
                            <div className="row text-center body-row  py-2">
                                <div className="col ">மாலை</div>
                                <div className="col">{timeDetails.gowrineram_e ?? "-"}</div>
                            </div>

                        </div>
                    </div>
                )}
                {raguKuligaiEmakandam && (
                    <div className="timing-card my-3 border rounded shadow-sm overflow-hidden">
                        {/* 3-column header */}
                        <div className="row text-center text-white header-row py-1">
                            <div className="col ">இராகு</div>
                            <div className="col ">குளிகை</div>
                            <div className="col">எமகண்டம்</div>
                        </div>

                        {/* 3-column values */}
                        <div className="row text-center body-row py-2">
                            <div className="col">
                                {raguKuligaiEmakandam?.ragu && raguKuligaiEmakandam.ragu.trim() !== ''
                                    ? raguKuligaiEmakandam.ragu
                                    : '-'}
                            </div>
                            <div className="col">
                                {raguKuligaiEmakandam?.kuligai && raguKuligaiEmakandam.kuligai.trim() !== ''
                                    ? raguKuligaiEmakandam.kuligai
                                    : '-'}
                            </div>
                            <div className="col">
                                {raguKuligaiEmakandam?.emakandam && raguKuligaiEmakandam.emakandam.trim() !== ''
                                    ? raguKuligaiEmakandam.emakandam
                                    : '-'}
                            </div>
                        </div>

                        <div className="dotted-line"></div>


                        <div className="row text-center body-row  py-2">
                            <div className="col ">சூலம் - {raguKuligaiEmakandam?.soolam && raguKuligaiEmakandam.soolam.trim() !== '' ? raguKuligaiEmakandam.soolam : "-"}</div>
                            <div className="col">பரிகாரம் - {raguKuligaiEmakandam?.parikaram && raguKuligaiEmakandam.parikaram.trim() !== '' ? raguKuligaiEmakandam.parikaram : '-'}</div>
                        </div>
                        <div className="dotted-line"></div>
                        <div className="text-center body-row py-2">
                            {raasiNames[timeDetails?.laknam] ?? ""} லக்னம் இருப்பு {timeDetails?.laknam_time ?? "-"}
                        </div>
                        <div className="dotted-line"></div>
                        {/* 2-column pink title row */}
                        <div className="row text-center body-row py-1 pink-title">
                            <div className="col border-end">சூரிய உதயம்</div>
                            <div className="col">கரணன்</div>
                        </div>
                        <div className="row text-center body-row py-1">
                            <div className="col border-end">{timeDetails?.sooriya_r ?? "-"}</div>
                            <div className="col">{timeDetails?.karanam ?? "-"}</div>
                        </div>

                        <div className="dotted-line"></div>

                        {/* 2-column pink title row */}
                        <div className="row text-center body-row py-1 pink-title">
                            <div className="col border-end">திதி</div>
                            <div className="col">நட்சத்திரம்</div>
                        </div>
                        <div className="row text-center body-row py-1">
                            <div className="col border-end">
                                {raguKuligaiEmakandamAdditional?.thiti || '-'}
                            </div>
                            <div className="col">
                                {starGet(starDetails)}
                            </div>

                        </div>

                        <div className="dotted-line"></div>

                        {/* 2-column pink title row */}
                        <div className="row text-center body-row py-1 pink-title">
                            <div className="col border-end">நாமயோகம்</div>
                            <div className="col">கரணம்</div>
                        </div>
                        <div className="row text-center body-row py-1">
                            <div className="col border-end">
                                {raguKuligaiEmakandamAdditional?.nama_yogam || '-'}

                            </div>
                            <div className="col">
                                {raguKuligaiEmakandamAdditional?.karanam || '-'}

                            </div>
                        </div>

                        <div className="dotted-line"></div>

                        {/* 2-column pink title row */}
                        <div className="row text-center body-row py-1 pink-title">
                            <div className="col border-end">அமிர்தாதி யோகம்</div>
                            <div className="col">சந்திராஷ்டமம்</div>
                        </div>
                        <div className="row text-center body-row py-1">
                            <div className="col border-end">
                                {raguKuligaiEmakandamAdditional?.yokam || '-'}

                            </div>
                            <div className="col">
                                {raguKuligaiEmakandamAdditional?.chanthran || '-'}

                            </div>
                        </div>
                        <div className="dotted-line"></div>
                        <div className="row text-center body-row py-1 pink-title">
                            <div className="col border-end">நேத்திரம்</div>
                            <div className="col">ஜீவன்</div>
                        </div>
                        <div className="row text-center body-row py-1">
                            <div className="col border-end">
                                {raguKuligaiEmakandamAdditional?.nethiram || '-'}

                            </div>
                            <div className="col">
                                {raguKuligaiEmakandamAdditional?.jeevan || '-'}

                            </div>
                        </div>
                    </div>
                )}
                {rasiBoxDetails === null ? (
                    <div className="text-center">No Kocharam Details Available</div>
                ) :
                    <div className="horoscope-grid mx-auto">
                        {/* First row */}
                        <div className="cell">
                            {rasiBoxDetails.c1 && rasiBoxDetails.c1.trim() !== '-'
                                ? rasiBoxDetails.c1
                                : ''}
                        </div>
                        <div className="cell">
                            {rasiBoxDetails.c2 && rasiBoxDetails.c2.trim() !== '-'
                                ? rasiBoxDetails.c2
                                : ''}
                        </div>

                        <div className="cell">
                            {rasiBoxDetails.c3 && rasiBoxDetails.c3.trim() !== '-'
                                ? rasiBoxDetails.c3
                                : ''}
                        </div>

                        <div className="cell">
                            {rasiBoxDetails.c4 && rasiBoxDetails.c4.trim() !== '-'
                                ? rasiBoxDetails.c4
                                : ''}
                        </div>

                        {/* Second row */}
                        <div className="cell">
                            {rasiBoxDetails.c12 && rasiBoxDetails.c12.trim() !== '-'
                                ? rasiBoxDetails.c12
                                : ''}
                        </div>
                        <div className="cell center-content span-row-2 span-col-2">
                            {rasiBoxDetails.m1 && rasiBoxDetails.m1.trim() !== '-' && (
                                <div>
                                    {rasiBoxDetails.m1}
                                </div>
                            )}

                            {rasiBoxDetails.m2 && rasiBoxDetails.m2.trim() !== '-' && (
                                <div>
                                    {rasiBoxDetails.m2}
                                </div>
                            )}
                            {rasiBoxDetails.m3 && rasiBoxDetails.m3.trim() !== '-' && (
                                <div>
                                    {rasiBoxDetails.m3}
                                </div>
                            )}
                            {rasiBoxDetails.m4 && rasiBoxDetails.m4.trim() !== '-' && (
                                <div>
                                    {rasiBoxDetails.m4}
                                </div>
                            )}
                            {rasiBoxDetails.m5 && rasiBoxDetails.m5.trim() !== '-' && (
                                <div>
                                    {rasiBoxDetails.m5}
                                </div>
                            )}
                            {rasiBoxDetails.m6 && rasiBoxDetails.m6.trim() !== '-' && (
                                <div>
                                    {rasiBoxDetails.m6}
                                </div>
                            )}
                            {rasiBoxDetails.m7 && rasiBoxDetails.m7.trim() !== '-' && (
                                <div>
                                    {rasiBoxDetails.m7}
                                </div>
                            )}

                        </div>
                        <div className="cell">
                            {rasiBoxDetails.c5 && rasiBoxDetails.c5.trim() !== '-'
                                ? rasiBoxDetails.c5
                                : ''}
                        </div>
                        {/* Third row */}

                        <div className="cell">
                            {rasiBoxDetails.c11 && rasiBoxDetails.c11.trim() !== '-'
                                ? rasiBoxDetails.c11
                                : ''}
                        </div>
                        <div className="cell">
                            {rasiBoxDetails.c6 && rasiBoxDetails.c6.trim() !== '-'
                                ? rasiBoxDetails.c6
                                : ''}
                        </div>

                        {/* Fourth row - 4 empty cells */}
                        <div className="cell">
                            {rasiBoxDetails.c10 && rasiBoxDetails.c10.trim() !== '-'
                                ? rasiBoxDetails.c10
                                : ''}
                        </div>
                        <div className="cell">
                            {rasiBoxDetails.c9 && rasiBoxDetails.c9.trim() !== '-'
                                ? rasiBoxDetails.c9
                                : ''}
                        </div>
                        <div className="cell">
                            {rasiBoxDetails.c8 && rasiBoxDetails.c8.trim() !== '-'
                                ? rasiBoxDetails.c8
                                : ''}
                        </div>
                        <div className="cell">
                            {rasiBoxDetails.c7 && rasiBoxDetails.c7.trim() !== '-'
                                ? rasiBoxDetails.c7
                                : ''}
                        </div>
                    </div>
                }
                {/* Today's Rasi Palan Table */}
                {rasiDetails === null ? (
                    <div className="text-center">No Rasi Details Available</div>
                ) :
                    <div className="timing-card my-3  rounded shadow-sm overflow-hidden">

                        <h6 className="rasipalan-title">இன்றைய ராசிபலன்</h6>
                        <div className="rasipalan-grid">
                            <div className="rasipalan-row">
                                <div className="rasipalan-cell border-end border-dark">
                                    <div className="split-line" style={{ fontSize: "14px" }}>
                                        <span><div >மேஷம்</div></span>
                                        <span>{rasiDetails.mesam}</span>
                                    </div>
                                </div>
                                <div className="rasipalan-cell">
                                    <div className="split-line" style={{ fontSize: "14px" }}>
                                        <span>ரிஷபம்</span>
                                        <span>{rasiDetails.risibam}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="dotted-line"></div>

                            <div className="rasipalan-row">
                                <div className="rasipalan-cell border-end border-dark">
                                    <div className="split-line" style={{ fontSize: "14px" }}>
                                        <span>மிதுனம்</span>
                                        <span>{rasiDetails.mithunam}</span>
                                    </div>
                                </div>
                                <div className="rasipalan-cell">
                                    <div className="split-line" style={{ fontSize: "14px" }}>
                                        <span>கடகம்</span>
                                        <span>{rasiDetails.kadakam}</span>
                                    </div>
                                </div>
                            </div>



                            <div className="dotted-line"></div>
                            <div className="rasipalan-row">
                                <div className="rasipalan-cell border-end border-dark">
                                    <div className="split-line" style={{ fontSize: "14px" }}>
                                        <span>சிம்மம்</span>
                                        <span>{rasiDetails.simmam}</span>
                                    </div>
                                </div>
                                <div className="rasipalan-cell">
                                    <div className="split-line" style={{ fontSize: "14px" }}>
                                        <span>கன்னி</span>
                                        <span>{rasiDetails.kanni}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="dotted-line"></div>
                            <div className="rasipalan-row">
                                <div className="rasipalan-cell border-end border-dark">
                                    <div className="split-line" style={{ fontSize: "14px" }}>
                                        <span>துலாம்</span>
                                        <span>{rasiDetails.thulam}</span>
                                    </div>
                                </div>
                                <div className="rasipalan-cell">
                                    <div className="split-line" style={{ fontSize: "14px" }}>
                                        <span>விருச்சிகம்</span>
                                        <span>{rasiDetails.viruchakam}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="dotted-line"></div>

                            <div className="rasipalan-row">
                                <div className="rasipalan-cell border-end border-dark">
                                    <div className="split-line" style={{ fontSize: "14px" }}>
                                        <span>தனுசு</span>
                                        <span>{rasiDetails.dhanusu}</span>
                                    </div>
                                </div>
                                <div className="rasipalan-cell">
                                    <div className="split-line" style={{ fontSize: "14px" }}>
                                        <span>மகரம்</span>
                                        <span>{rasiDetails.makaram}</span>
                                    </div>
                                </div>
                            </div>


                            <div className="dotted-line"></div>
                            <div className="rasipalan-row">
                                <div className="rasipalan-cell border-end border-dark">
                                    <div className="split-line" style={{ fontSize: "14px" }}>
                                        <span>கும்பம்</span>
                                        <span>{rasiDetails.kumbam}</span>
                                    </div>
                                </div>
                                <div className="rasipalan-cell">
                                    <div className="split-line" style={{ fontSize: "14px" }}>
                                        <span>மீனம்</span>
                                        <span>{rasiDetails.meenam}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {/* Additional Sections */}
                <div
                    className="timing-card my-3 border rounded shadow-sm overflow-hidden"
                    style={{ paddingLeft: '1rem', paddingRight: '1rem', paddingTop: '1rem', textAlign: 'left', paddingBottom: '1rem', }}
                >
                    {/* Heading row with icon */}
                    <div className="d-flex justify-content-between align-items-center">
                        <h6 style={{ fontWeight: 'bold' }}>பொன்மொழி :</h6>
                        {/* <i class="bi bi-box-arrow-up-right"></i> */}
                    </div>

                    {/* Text content */}
                    <p className="mt-2 mb-0">
                        {raguKuligaiEmakandamAdditional?.quote || '-'}

                    </p>
                </div>

                {dayDetails && (
                    <div
                        className="timing-card my-3 border rounded shadow-sm overflow-hidden"
                        style={{ paddingLeft: '1rem', paddingRight: '1rem', paddingTop: '1rem', textAlign: 'left' }}
                    >
                        {/* பிறந்த நாள் */}
                        {dayDetails.birthday && dayDetails.birthday !== '-' && (
                            <>
                                <div className="d-flex justify-content-between align-items-center">
                                    <h6 style={{ fontWeight: 'bold' }}>பிறந்த நாள் :</h6>
                                    {/* <i className="bi bi-box-arrow-up-right" style={{ fontSize: '1.2rem' }}></i> */}
                                </div>
                                <p>{dayDetails.birthday}</p>
                            </>
                        )}

                        {/* நினைவு நாள் */}
                        {(!dayDetails.birthday || dayDetails.birthday === '-') && dayDetails.death && dayDetails.death !== '-' && (
                            <>
                                <div className="d-flex justify-content-between align-items-center">
                                    <h6 style={{ fontWeight: 'bold' }}>நினைவு நாள் :</h6>
                                    {/* <i className="bi bi-box-arrow-up-right" style={{ fontSize: '1.2rem' }}></i> */}
                                </div>
                                <p>{dayDetails.death}</p>
                            </>
                        )}

                        {/* If both come (already handled above for பிறந்த நாள்), just display நினைவு நாள் without icon */}
                        {dayDetails.birthday && dayDetails.birthday !== '-' && dayDetails.death && dayDetails.death !== '-' && (
                            <>
                                <h6 style={{ fontWeight: 'bold' }}>நினைவு நாள் :</h6>
                                <p>{dayDetails.death}</p>
                            </>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default CalendarCard;
